/**
 * Brand orange, two jobs.
 *
 * ORANGE is the brand fill — buttons, panel accents, icons, avatars. It is a
 * non-text colour, so no contrast rule applies to it.
 *
 * ORANGE_TEXT is the ONLY orange for text (Rod, 2026-09-06). #F67A1A on white is
 * 2.72:1 and fails WCAG AA at every size; #E56A0A is 3.28:1 and passes for bold
 * text at 18.66 px and up. Orange text is always bold. 🛑 Never introduce a third
 * orange for text — #BF5507 was rejected by name.
 */
export const ORANGE = '#F67A1A';
export const ORANGE_TEXT = '#E56A0A';

/** Orange text is always bold and a step larger than the copy around it — at
 *  #E56A0A a 13 px / 700 link reads washed out (Rod, 2026-09-06). Use these on
 *  every orange text node instead of ad-hoc weight/size. */
export const ORANGE_LINK_STYLE = { color: ORANGE_TEXT, fontWeight: 800, fontSize: '15px' } as const;
export const ORANGE_EYEBROW_SX = { color: ORANGE_TEXT, fontWeight: 800, fontSize: '14px', letterSpacing: 1.4 } as const;

/** Muted/helper text. #9aa3ab (2.56:1) and #6b7280 (4.47:1 on the page grey)
 *  both failed WCAG AA; #5f6b7a is 5.4:1 on white and 5.0:1 on #f5f6f8. */
export const MUTED_TEXT = '#5f6b7a';
